import {
  START_CALL_SESSION,
  START_CALL_SESSION_SUCCESS,
  START_CALL_SESSION_ERROR,
  STOP_CALL_SESSION,
  STOP_CALL_SESSION_SUCCESS,
  STOP_CALL_SESSION_ERROR,
} from '../constants/ActionTypes';

export const startCallSession = ({ userId, isPrivateCall = false }) => ({
  type: START_CALL_SESSION,
  payload: { userId, isPrivateCall },
});

export const startCallSessionSuccess = ({ userId, responseStatus, directPhoneNumber }) => ({
  type: START_CALL_SESSION_SUCCESS,
  payload: { userId, responseStatus, directPhoneNumber },
});

export const startCallSessionError = ({ userId, error }) => ({
  type: START_CALL_SESSION_ERROR,
  payload: { userId, error },
});

export const stopCallSession = userId => ({
  type: STOP_CALL_SESSION,
  payload: { userId },
});

export const stopCallSessionSuccess = ({ userId, responseStatus }) => ({
  type: STOP_CALL_SESSION_SUCCESS,
  payload: { userId, responseStatus },
});

export const stopCallSessionError = ({ userId, error }) => ({
  type: STOP_CALL_SESSION_ERROR,
  payload: { userId, error },
});
